import type { ScheduleMode } from './types';

// Single source of truth for mode-family checks. Funnel new
// `if (mode === '...')` branches through these helpers so that adding
// a future mode (e.g. bulk-manual) is a one-file edit, not a grep.

export const isSelfScheduleMode = (mode: ScheduleMode): boolean =>
  mode === 'self-schedule' || mode === 'self-schedule-adhoc';

export const isAdhocMode = (mode: ScheduleMode): boolean =>
  mode === 'adhoc' || mode === 'self-schedule-adhoc';

export const isManualMode = (mode: ScheduleMode): boolean =>
  mode === 'manual' || mode === 'adhoc';
